var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlm = function SvgXlm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xlm_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22 0a22 22 0 1 0 0 44 22 22 0 0 0 0-44M6.985 25.282a1.376 1.376 0 0 1 .733-1.834l2.824-1.173A11.475 11.475 0 0 1 22 10.542a11.7 11.7 0 0 1 3.3.458 1.38 1.38 0 1 1-.807 2.64A8.8 8.8 0 0 0 22 13.292a8.726 8.726 0 0 0-8.672 7.865l20.974-8.672a1.374 1.374 0 1 1 1.063 2.53l-26.583 11q-.257.105-.532.11a1.38 1.38 0 0 1-1.265-.843m29.333-4.767-2.823 1.173A11.48 11.48 0 0 1 22 33.458 11 11 0 0 1 18.993 33a1.375 1.375 0 1 1 .715-2.658 8.6 8.6 0 0 0 2.292.311 8.727 8.727 0 0 0 8.672-7.865L9.698 31.515c-.168.07-.349.107-.531.11a1.375 1.375 0 0 1-.532-2.64l26.583-11a1.375 1.375 0 1 1 1.064 2.53z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xlm_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgXlm;